import {
  copyFileById,
  destroyFile,
  forceFileDownload,
  getMongoFileId,
  getPrincipalName,
  getTokenHeader,
  getThumbnailUrl,
  getPictureUrlDatePath
} from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment";
import "./POI.scss";
import _ from "lodash";
import { v4 as uuid } from "uuid";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import POIFilter from "@/components/POI/POIFilter/POIFilter.vue";
import POIEditDialog from "@/components/POI/POIEditDialog/POIEditDialog.vue";
import ExportXslxDialog from "@/components/POI/ExportXslxDialog/ExportXslxDialog.vue";
import ExportCsvDialog from "@/components/POI/ExportCsvDialog/ExportCsvDialog.vue";
import ColumnVisibilitySelector from "@/components/Common/ColumnVisibilitySelector/ColumnVisibilitySelector.vue";
import CategorySetDialog from "@/components/Events/EventListTable/CategorySetDialog/CategorySetDialog.vue";
import FeatureSetDialog from "@/components/Events/EventListTable/FeatureSetDialog/FeatureSetDialog.vue";
import EventSuggestionDialog from "@/components/Events/EventListTable/EventSuggestionDialog/EventSuggestionDialog.vue";
import { buildQuery, defaultPoi, getPois } from "@/helpers/poiHelper";
import { uploadFile } from "@/helpers/fileHelper";
import XLSX from "xlsx";
import { imports } from "@/helpers/poiHelper";
import { updateOpLoc } from "@/helpers/opLocHelper";
import {
  buildSuggestionPromptPayload,
  executeSuggestionPrompt,
  getCurrentUserIdFromSession
} from "@/helpers/suggestionHelper";
import {
  countSuggestionItems,
  extractResolvedLabels,
  formatNumberDe,
  getAppliedStateForItemByKey,
  getNormalizedIdList,
  normalizeEntityId,
  resolveLabelFromValue,
  getSuggestionErrorForItemByKey,
  getSuggestionMapKey,
  getSuggestionsForItemByKey,
  isItemLoadingSuggestionsByKey,
  isValidBatchMode,
  normalizeLabel,
  removePendingEntry,
  runBulkTagUpdateRequest,
  syncSelectionWithLatestItems,
  togglePendingEntry
} from "@/helpers/batchDialogHelper";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const CATEGORY_SUGGESTION_PROMPT_SHORT_ID = "sBDHKQgbT";
const FEATURE_SUGGESTION_PROMPT_SHORT_ID = "sBDHKQgbT";

const defaultFilter = {
  itemsPerPage: 10
};

let initialOptions = {
  itemsPerPage: 10
};

export default {
  name: "POI",
  props: ["editId"],
  data: () => ({
    loading: true,
    isValid: false,
    dialog: false,
    typeDialog: false,
    dialogDelete: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    search: "",
    defaultFilter: {
      itemsPerPage: 10,
      categoryGroup: "",
      category: "",
      city: "",
      features: [],
      active: false,
      highlight: false
    },
    headers: [
      {
        text: "Vorschaubild",
        align: "start",
        value: "image",
        sortable: false
      },
      {
        text: "",
        align: "start",
        value: "import",
        sortable: false
      },
      {
        text: "Ortsname",
        align: "start",
        value: "title"
      },
      { text: "Typ", value: "categoryType" },
      { text: "Kategorie", value: "categoryTitle" },
      { text: "Ort", value: "address.city" },
      { text: "Zuletzt geändert", value: "updatedAt" },
      { text: "Aktiv (Veröffentlicht)", value: "active" },
      { text: "Top-POI", value: "highlight" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "10%"
      }
    ],
    visibleColumnKeys: [
      "image",
      "import",
      "title",
      "categoryType",
      "categoryTitle",
      "address.city",
      "updatedAt",
      "active",
      "highlight",
      "actions"
    ],
    editedIndex: -1,
    editedItem: {
      title: "",
      subTitle: "",
      shortTitle: "",
      sortTitle: "",
      category: "",
      additionalCategories: [],
      slug: "",
      manualSlug: false,
      highlight: false,
      active: true,
      name: "",
      area: "",
      nation: "",
      address: { country: "Deutschland" },
      online: {},
      webcamLinks: [{}],
      showWebcamsFirst: false,
      mainFiles: [],
      fileFiles: [],
      pictures: [],
      files: [],
      openingHours: {
        freeAccess: true,
        closedDays: [{}],
        seasonalOpeningHours: [],
        specialDays: [{}],
        description: {
          description: "",
          seasonalDescription: "",
          arrivalInformation: "",
          hygieneNoticeText: "",
          hygieneNoticeIUrl: ""
        }
      },
      state: {
        lastAscent: "", // Zeit
        lastDescent: "", // Zeit
        firstAscent: "", // Zeit
        ascent: undefined,
        descent: undefined,
        seasonStart: "",
        seasonEnd: "",
        prognosisCountLift: undefined,
        prognosisCountTrailClassic: undefined,
        prognosisCountTrailSkating: undefined,
        prognosisCountTrail: undefined,
        prognosisLengthLift: undefined,
        prognosisLengthTrail: undefined,
        prognosisLengthTrailClassic: undefined,
        prognosisLengthTrailSkating: undefined,
        state: "openingHours",
        stateInfo: "",
        valleySnowDepth: undefined,
        mountainSnowDepth: undefined,
        avalancheLevel: "",
        lastSnowFall: "",
        freshSnow: undefined,
        capacityPerUnit: undefined,
        carriage: undefined,
        drivingTime: "",
        valleySeaLevel: undefined,
        mountainSeaLevel: undefined,
        height: undefined,
        valleyLength: undefined,
        heightDifference: undefined,
        hasSnowMaking: false,
        hasValleyRun: false,
        lakeTemperature: "",
        waterQuality: "",
        temperature: undefined,
        difficulty: "",
        trackType: "",
        walkingTime: "", // Zeit
        floodlightAt: [],
        floodlightFrom: "", // Zeit
        floodlightUntil: "", // Zeit
        lastTimeGroomed: "", // Zeit
        lastDateGroomed: "",
        length: undefined,
        lowestHeight: undefined,
        highestHeight: undefined,
        snowTexture: "",
        pathCondition: [],
        bestSeason: [],
        location: "",
        condition: undefined,
        slopeCondition: "",
        experienceFactor: undefined,
        landscapeFactor: undefined,
        weatherCondition: "",
        sight: "",
        withWithoutParkingFee: "",
        parkingPayment: [],
        maxParkingTime: null,
        parkingTime: null,
        parkingFee: null
      },
      pricePackages: [
        {
          id: 1,
          services: [],
          tableTitle: "Preise"
        }
      ],
      route: {
        gpx: { title: "", url: "", id: "" },
        image: { title: "", url: "", id: "" },
        description: {
          publicTransit: "",
          startingPointDescr: "",
          parking: "",
          equipment: "",
          tip: "",
          additionalInformation: "",
          destination: "",
          directions: "",
          safetyGuidelines: "",
          trackSignage: ""
        }
      },
      currentMessage: {},
      features: [],
      seasonWeeks: [{ id: uuid() }],
      contact: {
        showContact: "address"
      },
      additionalData: [{}],
      license: {},
      geo: {},
      searchTerms: [],
      relatedPois: [],
      description: { description: "", seasonalDescription: "" },
      shortDescription: { description: "", seasonalDescription: "" },
      principal: "",
      regions: [],
      excursionTickers: [],
      exhibitions: [],
      contactPerson: {
        name: "",
        gender: "",
        title: "",
        phoneNumber: "",
        eMail: "",
        picture: {}
      },
      conferenceInfos: {
        rooms: []
      }
    },
    changed: false,

    pois: [],
    allPois: [],
    overlay: false,
    exportData: [],
    poiCount: 0,
    options: {
      ...initialOptions
    },
    step: 1,
    filter: { ..._.cloneDeep(defaultFilter) },
    MAIN_GREEN: "#00636C",
    MAIN_GREY: "#7a7a7a",
    exportingImages: false,
    destroyList: [],
    currentSearchRequest: null,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0,
    selectedPois: [],
    allPagesSelected: false,
    categorySetDialogOpen: false,
    categorySetMode: "add",
    categorySetQuery: "",
    categorySetPending: [],
    categorySetItemsLoaded: [],
    categorySetSaving: false,
    categorySetConfirmOpen: false,
    featureSetDialogOpen: false,
    featureSetMode: "add",
    featureSetQuery: "",
    featureSetPending: [],
    featureSetItemsLoaded: [],
    featureSetSaving: false,
    featureSetConfirmOpen: false,
    poiSuggestionDialogOpen: false,
    currentSuggestionType: "category",
    dialogItemsLoaded: [],
    suggestedCategoriesById: {},
    suggestionErrorsById: {},
    appliedSuggestionsById: {},
    categoriesForPrompt: [],
    featuresForPrompt: [],
    suggestingItemId: null,
    suggestingCategories: false,
    applyingCategories: false,
    applyCompleted: false,
    suggestionsCompleted: false
  }),
  components: {
    ColumnVisibilitySelector,
    POIFilter,
    POIEditDialog,
    ExportXslxDialog,
    ExportCsvDialog,
    CategorySetDialog,
    FeatureSetDialog,
    EventSuggestionDialog
  },
  async mounted() {
    const itemsPerPage = defaultFilter.itemsPerPage;
    this.filter.itemsPerPage = this.filter.limit = itemsPerPage;
    await this.refreshPois(this.options);
    if (this.principal) {
      try {
        await this.$store.dispatch("getCategoryGroups", false);
        await this.$store.dispatch("getAllUsers");
        await this.$store.dispatch("getCategoryTypes");
        await this.$store.dispatch("getCities");
        await this.$store.dispatch("getRegions", { listSearch: true });
        await this.$store.dispatch("getFeatureGroupsForPois", this.isRegion);
        await this.$store.dispatch("getThirdPartySystems", { module: "POIs" });
        if (this.editId) {
          const headers = getTokenHeader();
          const { data: poiToEdit } = await axios.get(
            `${env.poi_api_client_url}poi/${this.editId}`,
            {
              headers
            }
          );
          await this.editItem(poiToEdit);
        }
        this.loading = false;
      } catch (ex) {
        this.createError(ex);
      }
    } else alert("Bitte wählen sie einen Mandanten aus");
  },

  computed: {
    currentHeaders() {
      const selected = new Set(this.visibleColumnKeys);
      return this.headers.filter(header => selected.has(header.value));
    },
    columnOptions() {
      return this.headers.map(header => ({
        text: header.text || header.value,
        value: header.value
      }));
    },
    columnSettingsStorageKey() {
      return "poi_columns";
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal._id;
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    categoryTypesById() {
      return this.$store.state.categoryTypesById;
    },
    categoryGroupsForPoi() {
      return this.categoryGroups?.filter(cg => {
        if (cg.categoryType !== this.editedItem.categoryType) {
          return false;
        }

        if (Array.isArray(cg.services)) {
          return !cg.services?.length;
        }
        return true;
      });
    },
    categories() {
      return _.flatten(
        this.$store.state.categoryGroups?.map(ct => ct.categories)
      );
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    categoriesById() {
      const categoriesById = {};

      this.categories?.forEach(cat => {
        categoriesById[cat._id] = cat.title;
      });
      return categoriesById;
    },
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    users() {
      return this.$store.state.users;
    },
    cities() {
      return this.$store.state.cities;
    },
    principals() {
      return this.$store.state.principals;
    },

    isRegion() {
      return (
        this.$store.state.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    },
    featureGroups() {
      return this.$store.state.featureGroups;
    },
    regions() {
      return _.sortBy(this.$store.state.regions, "title");
    },
    hasBatchSelection() {
      return this.selectedPois.length > 0 || this.allPagesSelected;
    },
    selectionLabel() {
      if (this.allPagesSelected) {
        return `Alle ${this.poiCount} POIs ausgewählt`;
      }
      return `${this.selectedPois.length} von ${this.poiCount} ausgewählt`;
    },
    categorySetTotal() {
      return this.categorySetItemsLoaded.length;
    },
    allCategoryOptions() {
      return _.uniqBy(
        _.flatten(
          (this.categoryGroups || []).map(group =>
            (group?.categories || []).map(category => ({
              id: this.getPoiStateKey(category),
              title: `${category?.title || category?.name || ""}`.trim()
            }))
          )
        ).filter(category => category.id && category.title),
        "id"
      );
    },
    categorySetKnownTags() {
      return [...new Set(this.allCategoryOptions.map(option => option.title))];
    },
    categorySetTagIdByNormalizedTag() {
      const map = {};
      this.allCategoryOptions.forEach(option => {
        const normalized = this.normalizeCategoryLabel(option.title);
        if (!normalized || map[normalized]) return;
        map[normalized] = option.id;
      });
      (this.categoryGroups || []).forEach(group => {
        const groupCategories = Array.isArray(group?.categories)
          ? group.categories
          : [];
        const rootCategoryEntity = groupCategories.find(
          category => category?.isCategoryGroup === true
        );
        const rootEntity = rootCategoryEntity || group;
        const rootId = this.getPoiStateKey(rootEntity);
        const rootTitle = `${rootEntity?.title ||
          rootEntity?.name ||
          ""}`.trim();
        const normalizedRootTitle = this.normalizeCategoryLabel(rootTitle);
        if (normalizedRootTitle && rootId && !map[normalizedRootTitle]) {
          map[normalizedRootTitle] = rootId;
        }

        const groupTitle = `${group?.title || group?.name || ""}`.trim();
        const normalizedGroupTitle = this.normalizeCategoryLabel(groupTitle);
        if (normalizedGroupTitle && rootId && !map[normalizedGroupTitle]) {
          map[normalizedGroupTitle] = rootId;
        }
      });
      return map;
    },
    categorySetStatsByTag() {
      const statsMap = {};
      const increment = tag => {
        const normalizedTag = `${tag || ""}`.trim();
        if (!normalizedTag) return;
        if (!statsMap[normalizedTag]) {
          statsMap[normalizedTag] = { has: 0 };
        }
        statsMap[normalizedTag].has += 1;
      };

      this.categorySetItemsLoaded.forEach(item => {
        const additionalCategoryIds = this.getNormalizedIdList(
          item?.additionalCategories || item?.additional_categories || []
        );
        const categoryTags = additionalCategoryIds
          .map(id => this.getCategoryTitleById(id))
          .map(tag => `${tag || ""}`.trim())
          .filter(Boolean);
        [...new Set(categoryTags)].forEach(tag => increment(tag));
      });

      return statsMap;
    },
    categorySetGroups() {
      const mode = this.categorySetMode;
      const query = this.normalizeCategoryLabel(this.categorySetQuery);
      const pending = this.categorySetPending;

      return (this.categoryGroups || [])
        .map((group, groupIndex) => {
          const groupId =
            this.getPoiStateKey(group) || `category_group_${groupIndex}`;
          const groupTitle = `${group?.title || group?.name || ""}`.trim();
          const rawCategories = Array.isArray(group?.categories)
            ? group.categories
            : [];
          const groupCategoryEntity = rawCategories.find(
            category => category?.isCategoryGroup === true
          );
          const rootEntity = groupCategoryEntity || group;
          const rootId = this.getPoiStateKey(rootEntity);
          const childCategoryEntities = rawCategories.filter(
            category => category?.isCategoryGroup !== true
          );
          const groupTag = `${rootEntity?.title ||
            rootEntity?.name ||
            groupTitle}`.trim();

          const entries = childCategoryEntities
            .map(category => {
              const tag = `${category?.title || category?.name || ""}`.trim();
              if (!tag) return null;
              if (!this.isCategoryTagVisible(tag)) return null;
              const stats = this.getCategorySetStats(tag);
              return {
                id: `${groupId}::${tag}`,
                tag,
                title: tag,
                checked: pending.some(
                  pendingEntry =>
                    pendingEntry.tag === tag && pendingEntry.type === mode
                ),
                countLabel:
                  mode === "remove"
                    ? `${this.formatNumberDe(
                        stats.has
                      )} von ${this.formatNumberDe(stats.total)}`
                    : ""
              };
            })
            .filter(Boolean)
            .filter(entry => {
              if (!query) return true;
              return this.normalizeCategoryLabel(entry.title).includes(query);
            });

          const groupSelectable = Boolean(groupTag && rootId);
          const groupChecked = pending.some(
            pendingEntry =>
              pendingEntry.tag === groupTag && pendingEntry.type === mode
          );
          const groupMatches = this.normalizeCategoryLabel(groupTitle).includes(
            query
          );
          const visibleEntries = query
            ? groupMatches
              ? entries
              : entries
            : entries;

          if (query && !groupMatches && !visibleEntries.length) return null;
          if (!query && !visibleEntries.length && !groupSelectable) return null;

          return {
            id: groupId,
            title: groupTitle,
            tag: groupTag,
            selectable: groupSelectable,
            checked: groupChecked,
            countLabel: "",
            entries: visibleEntries
          };
        })
        .filter(Boolean);
    },
    categorySetPendingChanges() {
      return this.categorySetPending.map((change, index) => {
        const stats = this.getCategorySetStats(change.tag);
        const addDetail = [
          `${this.formatNumberDe(stats.neu)} neu`,
          stats.has > 0 ? `${this.formatNumberDe(stats.has)} vorhanden` : ""
        ]
          .filter(Boolean)
          .join(" · ");
        return {
          id: `${change.type}:${change.tag}:${index}`,
          ...change,
          title: change.tag,
          detail:
            change.type === "add"
              ? addDetail
              : `${this.formatNumberDe(stats.has)} betroffen`
        };
      });
    },
    categorySetSummaryLabel() {
      if (!this.categorySetPendingChanges.length) return "";
      const addCount = this.categorySetPendingChanges.filter(
        change => change.type === "add"
      ).length;
      const removeCount = this.categorySetPendingChanges.filter(
        change => change.type === "remove"
      ).length;
      const parts = [];
      if (addCount > 0) parts.push(`${addCount} hinzufügen`);
      if (removeCount > 0) parts.push(`${removeCount} entfernen`);
      parts.push(`${this.formatNumberDe(this.categorySetTotal)} POIs`);
      return parts.join(" · ");
    },
    categorySetCanSave() {
      return (
        this.categorySetPendingChanges.length > 0 && !this.categorySetSaving
      );
    },
    featureSetTotal() {
      return this.featureSetItemsLoaded.length;
    },
    allFeatureOptions() {
      return _.uniqBy(
        _.flatten(
          (this.featureGroups || []).map(group =>
            (group?.features || []).map(feature => ({
              id: this.getPoiStateKey(feature),
              title: `${feature?.title ||
                feature?.name ||
                feature?.label ||
                ""}`.trim()
            }))
          )
        ).filter(feature => feature.id && feature.title),
        "id"
      );
    },
    featureSetKnownTags() {
      return [...new Set(this.allFeatureOptions.map(option => option.title))];
    },
    featureSetTagIdByNormalizedTag() {
      const map = {};
      this.allFeatureOptions.forEach(option => {
        const normalized = this.normalizeCategoryLabel(option.title);
        if (!normalized || map[normalized]) return;
        map[normalized] = option.id;
      });
      return map;
    },
    featureSetStatsByTag() {
      const statsMap = {};
      const increment = tag => {
        const normalizedTag = `${tag || ""}`.trim();
        if (!normalizedTag) return;
        if (!statsMap[normalizedTag]) {
          statsMap[normalizedTag] = { has: 0 };
        }
        statsMap[normalizedTag].has += 1;
      };

      this.featureSetItemsLoaded.forEach(item => {
        const featureIds = this.getNormalizedIdList(item?.features || []);
        const featureTags = featureIds
          .map(id => this.getFeatureTitleById(id))
          .map(tag => `${tag || ""}`.trim())
          .filter(Boolean);
        [...new Set(featureTags)].forEach(tag => increment(tag));
      });

      return statsMap;
    },
    featureSetGroups() {
      const mode = this.featureSetMode;
      const query = this.normalizeCategoryLabel(this.featureSetQuery);
      const pending = this.featureSetPending;

      return (this.featureGroups || [])
        .map((group, groupIndex) => {
          const groupId =
            this.getPoiStateKey(group) || `feature_group_${groupIndex}`;
          const groupTitle = `${group?.title ||
            group?.name ||
            "Merkmale"}`.trim();
          const entries = (group?.features || [])
            .map(feature => {
              const tag = `${feature?.title ||
                feature?.name ||
                feature?.label ||
                ""}`.trim();
              if (!tag) return null;
              if (!this.isFeatureTagVisible(tag)) return null;
              const stats = this.getFeatureSetStats(tag);
              return {
                id: `${groupId}::${tag}`,
                tag,
                title: tag,
                checked: pending.some(
                  pendingEntry =>
                    pendingEntry.tag === tag && pendingEntry.type === mode
                ),
                countLabel:
                  mode === "remove"
                    ? `${this.formatNumberDe(
                        stats.has
                      )} von ${this.formatNumberDe(stats.total)}`
                    : ""
              };
            })
            .filter(Boolean)
            .filter(entry => {
              if (!query) return true;
              return this.normalizeCategoryLabel(entry.title).includes(query);
            });

          if (!entries.length) return null;
          return {
            id: groupId,
            title: groupTitle,
            tag: "",
            selectable: false,
            checked: false,
            countLabel: "",
            entries
          };
        })
        .filter(Boolean);
    },
    featureSetPendingChanges() {
      return this.featureSetPending.map((change, index) => {
        const stats = this.getFeatureSetStats(change.tag);
        const addDetail = [
          `${this.formatNumberDe(stats.neu)} neu`,
          stats.has > 0 ? `${this.formatNumberDe(stats.has)} vorhanden` : ""
        ]
          .filter(Boolean)
          .join(" · ");
        return {
          id: `${change.type}:${change.tag}:${index}`,
          ...change,
          title: change.tag,
          detail:
            change.type === "add"
              ? addDetail
              : `${this.formatNumberDe(stats.has)} betroffen`
        };
      });
    },
    featureSetSummaryLabel() {
      if (!this.featureSetPendingChanges.length) return "";
      const addCount = this.featureSetPendingChanges.filter(
        change => change.type === "add"
      ).length;
      const removeCount = this.featureSetPendingChanges.filter(
        change => change.type === "remove"
      ).length;
      const parts = [];
      if (addCount > 0) parts.push(`${addCount} hinzufügen`);
      if (removeCount > 0) parts.push(`${removeCount} entfernen`);
      parts.push(`${this.formatNumberDe(this.featureSetTotal)} POIs`);
      return parts.join(" · ");
    },
    featureSetCanSave() {
      return this.featureSetPendingChanges.length > 0 && !this.featureSetSaving;
    },
    dialogItems() {
      return this.dialogItemsLoaded;
    },
    suggestionTypeLabel() {
      return this.currentSuggestionType === "feature"
        ? "Merkmale"
        : "Kategorien";
    },
    suggestionTypeSingularLabel() {
      return this.currentSuggestionType === "feature" ? "Merkmal" : "Kategorie";
    },
    dialogTitleLabel() {
      return "Vorschläge prüfen";
    },
    dialogSubtitleLabel() {
      return `${this.dialogItems.length} POIs`;
    },
    totalSuggestionCount() {
      return this.dialogItems.reduce((acc, item) => {
        return acc + this.getSuggestionsForItem(item).length;
      }, 0);
    },
    currentItemsCount() {
      return this.dialogItems.reduce(
        (acc, item) => acc + this.getCurrentLabels(item).length,
        0
      );
    },
    dialogStatusLabel() {
      if (this.totalSuggestionCount <= 0) return "";
      return `${this.totalSuggestionCount} Vorschläge offen`;
    },
    actionButtonLabel() {
      return "Abschließen";
    },
    hasSuggestionsToApply() {
      return this.totalSuggestionCount > 0;
    },
    customPoiImageTypes() {
      return this.principal?.poiImageTypes || [];
    },
    activeImports() {
      return imports.filter(_ => _.isActive(this.principal)).map(_ => _.typeId);
    }
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    async principal() {
      try {
        await this.refreshPois(this.options);
        await this.$store.dispatch("getCategoryGroups");
        await this.$store.dispatch("getCategoryTypes");
      } catch (ex) {
        this.createError(ex);
      }
    },
    async options(value) {
      // Check if the options have really changed
      initialOptions.itemsPerPage = 10;
      const isEqual = Object.keys(value).every(
        key => initialOptions[key] === value[key]
      );
      if (isEqual) {
        console.info("options are equal. no need to refresh pois");
        initialOptions.firstLoad = true;
        return;
      }

      this.debouncedRefreshPois();
    },
    selectedPois(newSelection) {
      if (this.allPagesSelected && newSelection.length !== this.poiCount) {
        this.allPagesSelected = false;
      }
    },
    search(value) {
      if (value?.length >= 3 || !value?.length) {
        this.debouncedRefreshPois();
      }
    },
    editedItem() {
      this.changed = true;
    },
    dialog(value) {
      if (value) {
        // Wait for Stepper to load
        setTimeout(() => {
          // Get stepper-numbering
          const steps = document.getElementsByClassName(
            "v-stepper__step__step"
          );

          // Overwrite numbering with index
          steps.forEach((step, index) => {
            step.innerHTML = index + 1;
          });
        }, 500);
      }
    },
    // Watchers needed to prevent the v-slider component forcing the values to be 0.
    "editedItem.state.experienceFactor"(newValue, oldValue) {
      this.forceUndefinedInsteadOfZeroStateValue(
        newValue,
        oldValue,
        "experienceFactor"
      );
    },
    "editedItem.state.landscapeFactor"(newValue, oldValue) {
      this.forceUndefinedInsteadOfZeroStateValue(
        newValue,
        oldValue,
        "landscapeFactor"
      );
    },
    "editedItem.state.condition"(newValue, oldValue) {
      this.forceUndefinedInsteadOfZeroStateValue(
        newValue,
        oldValue,
        "condition"
      );
    }
  },
  created() {
    this.debouncedRefreshPois = _.debounce(() => {
      this.refreshPois(this.options)
        .then(() => {
          console.info("poisearch refreshed/cancelled");
        })
        .catch(err => {
          console.error("Error in search watcher: ", err);
          this.createError(err);
        });
    }, 200);
  },
  methods: {
    updateOpLoc,
    getPrincipalName,
    getThumbnailUrl,
    formatNumberDe(value) {
      return formatNumberDe(value);
    },
    getPoiStateKey(itemOrId) {
      return normalizeEntityId(itemOrId);
    },
    getNormalizedIdList(values = []) {
      return getNormalizedIdList(values, value => this.getPoiStateKey(value));
    },
    canEditPoi(poi) {
      return poi?.principal === this.currentPrincipal && !poi?.deleted;
    },
    async getDialogSelectionItems() {
      const selectedItems = (this.selectedPois || []).filter(poi =>
        this.canEditPoi(poi)
      );
      if (!this.allPagesSelected) {
        return selectedItems.map(item => ({ ...item }));
      }

      const selectedIds = this.getNormalizedIdList(this.allPois || []);
      if (!selectedIds.length) {
        return selectedItems.map(item => ({ ...item }));
      }
      const loadedById = new Map(this.pois.map(item => [item._id, item]));
      const missingIds = selectedIds.filter(id => !loadedById.has(id));
      const loadedItems = selectedIds
        .map(id => loadedById.get(id))
        .filter(Boolean)
        .map(item => ({ ...item }));
      if (!missingIds.length) {
        return loadedItems.filter(poi => this.canEditPoi(poi));
      }
      const fetchedItems = await this.loadPoisByIds(missingIds);
      return [...loadedItems, ...fetchedItems].filter(poi =>
        this.canEditPoi(poi)
      );
    },
    async loadPoisByIds(ids = []) {
      const chunks = [];
      for (let index = 0; index < ids.length; index += 200) {
        chunks.push(ids.slice(index, index + 200));
      }
      const headers = getTokenHeader();
      const pois = [];
      for (let index = 0; index < chunks.length; index++) {
        // eslint-disable-next-line no-await-in-loop
        const result = await axios.post(
          `${env.poi_api_client_url}poi/exportPois`,
          chunks[index],
          { headers }
        );
        (result?.data || []).forEach(item => {
          if (Array.isArray(item)) {
            item.forEach(poi => pois.push(poi));
            return;
          }
          pois.push(item);
        });
      }
      return _.uniqBy(pois, "_id");
    },
    async loadPoiDetailsByIds(ids = []) {
      const poiIds = this.getNormalizedIdList(ids);
      if (!poiIds.length) return [];

      const headers = getTokenHeader();
      const detailPois = [];
      const chunkSize = 20;

      for (let index = 0; index < poiIds.length; index += chunkSize) {
        const chunk = poiIds.slice(index, index + chunkSize);
        // eslint-disable-next-line no-await-in-loop
        const detailChunk = await Promise.all(
          chunk.map(async poiId => {
            try {
              const { data } = await axios.get(
                `${env.poi_api_client_url}poi/${poiId}`,
                {
                  headers
                }
              );
              return data;
            } catch (error) {
              return null;
            }
          })
        );
        detailChunk.filter(Boolean).forEach(item => detailPois.push(item));
      }

      return _.uniqBy(detailPois, "_id");
    },
    async enrichDialogItemsWithDetails(items = []) {
      const sourceItems = (items || []).filter(Boolean);
      if (!sourceItems.length) return [];

      const sourceById = new Map(
        sourceItems.map(item => [this.getPoiStateKey(item), item])
      );
      const selectionIds = this.getNormalizedIdList(sourceItems);
      if (!selectionIds.length) return sourceItems;

      const detailItems = await this.loadPoiDetailsByIds(selectionIds);
      const detailById = new Map(
        detailItems.map(item => [this.getPoiStateKey(item), item])
      );

      return selectionIds
        .map(itemId => detailById.get(itemId) || sourceById.get(itemId))
        .filter(Boolean);
    },
    normalizeCategoryLabel(label) {
      return normalizeLabel(label);
    },
    getCategoryTitleById(categoryId) {
      return resolveLabelFromValue(categoryId, {
        resolveTitleById: id => {
          const category = this.allCategoryOptions.find(
            option => option.id === id
          );
          return category?.title || "";
        },
        getId: value => this.getPoiStateKey(value),
        labelKeys: ["title", "name", "short_title"],
        allowRawString: false
      });
    },
    getFeatureTitleById(featureId) {
      return resolveLabelFromValue(featureId, {
        resolveTitleById: id => {
          const feature = this.allFeatureOptions.find(
            option => option.id === id
          );
          return feature?.title || "";
        },
        getId: value => this.getPoiStateKey(value),
        labelKeys: ["title", "name", "label"],
        allowRawString: false
      });
    },
    resolveCategorySetTagId(tag) {
      return (
        this.categorySetTagIdByNormalizedTag[
          this.normalizeCategoryLabel(tag)
        ] || ""
      );
    },
    resolveFeatureSetTagId(tag) {
      return (
        this.featureSetTagIdByNormalizedTag[this.normalizeCategoryLabel(tag)] ||
        ""
      );
    },
    getCategorySetStats(tag) {
      const normalizedTag = `${tag || ""}`.trim();
      const has = this.categorySetStatsByTag[normalizedTag]?.has || 0;
      const total = Number(this.categorySetTotal) || 0;
      return {
        has,
        total,
        neu: Math.max(total - has, 0)
      };
    },
    getFeatureSetStats(tag) {
      const normalizedTag = `${tag || ""}`.trim();
      const has = this.featureSetStatsByTag[normalizedTag]?.has || 0;
      const total = Number(this.featureSetTotal) || 0;
      return {
        has,
        total,
        neu: Math.max(total - has, 0)
      };
    },
    isCategoryTagVisible(tag) {
      return this.categorySetKnownTags.includes(`${tag || ""}`.trim());
    },
    isFeatureTagVisible(tag) {
      return this.featureSetKnownTags.includes(`${tag || ""}`.trim());
    },
    async openCategoryDialog() {
      const selectionItems = await this.getDialogSelectionItems();
      if (!selectionItems.length) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens einen editierbaren POI auswählen."
        });
        return;
      }
      const hydratedSelection = await this.enrichDialogItemsWithDetails(
        selectionItems
      );

      this.categorySetMode = "add";
      this.categorySetQuery = "";
      this.categorySetPending = [];
      this.categorySetConfirmOpen = false;
      this.categorySetItemsLoaded = hydratedSelection;
      this.categorySetDialogOpen = true;
    },
    closeCategorySetDialog() {
      this.categorySetDialogOpen = false;
      this.categorySetPending = [];
      this.categorySetQuery = "";
      this.categorySetItemsLoaded = [];
      this.categorySetConfirmOpen = false;
    },
    setCategorySetMode(mode) {
      if (!isValidBatchMode(mode)) return;
      this.categorySetMode = mode;
      this.categorySetQuery = "";
    },
    setCategorySetQuery(query) {
      this.categorySetQuery = `${query || ""}`;
    },
    toggleCategorySetEntry(entry) {
      this.categorySetPending = togglePendingEntry(this.categorySetPending, {
        tag: entry?.tag || entry?.title || "",
        type: this.categorySetMode
      });
    },
    removeCategorySetPending(payload) {
      this.categorySetPending = removePendingEntry(
        this.categorySetPending,
        payload?.tag || payload || ""
      );
    },
    openCategorySetConfirm() {
      if (!this.categorySetCanSave || this.categorySetSaving) return;
      this.categorySetConfirmOpen = true;
    },
    closeCategorySetConfirm() {
      this.categorySetConfirmOpen = false;
    },
    async saveCategorySetChanges() {
      if (this.categorySetSaving) return;
      const poiIds = this.getNormalizedIdList(
        this.categorySetItemsLoaded || []
      );
      const addTagIds = [
        ...new Set(
          this.categorySetPending
            .filter(change => change.type === "add")
            .map(change => this.resolveCategorySetTagId(change.tag))
            .filter(Boolean)
        )
      ];
      const removeTagIds = [
        ...new Set(
          this.categorySetPending
            .filter(change => change.type === "remove")
            .map(change => this.resolveCategorySetTagId(change.tag))
            .filter(Boolean)
        )
      ];

      if (!poiIds.length || (!addTagIds.length && !removeTagIds.length)) return;

      this.categorySetSaving = true;
      try {
        if (addTagIds.length) {
          await this.runPoiBulkTagUpdate({
            ids: poiIds,
            field: "additionalCategories",
            tagIds: addTagIds,
            action: "add"
          });
        }
        if (removeTagIds.length) {
          await this.runPoiBulkTagUpdate({
            ids: poiIds,
            field: "additionalCategories",
            tagIds: removeTagIds,
            action: "remove"
          });
        }
        await this.refreshPois(this.options);
        await this.$store.dispatch(
          "createSuccess",
          `Kategorien fuer ${this.formatNumberDe(
            poiIds.length
          )} POIs gespeichert.`
        );
        this.closeCategorySetDialog();
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Kategorien konnten nicht gespeichert werden.",
          error
        });
      } finally {
        this.categorySetSaving = false;
      }
    },
    async openFeatureDialog() {
      const selectionItems = await this.getDialogSelectionItems();
      if (!selectionItems.length) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens einen editierbaren POI auswählen."
        });
        return;
      }
      const hydratedSelection = await this.enrichDialogItemsWithDetails(
        selectionItems
      );

      this.featureSetMode = "add";
      this.featureSetQuery = "";
      this.featureSetPending = [];
      this.featureSetConfirmOpen = false;
      this.featureSetItemsLoaded = hydratedSelection;
      this.featureSetDialogOpen = true;
    },
    closeFeatureSetDialog() {
      this.featureSetDialogOpen = false;
      this.featureSetPending = [];
      this.featureSetQuery = "";
      this.featureSetItemsLoaded = [];
      this.featureSetConfirmOpen = false;
    },
    setFeatureSetMode(mode) {
      if (!isValidBatchMode(mode)) return;
      this.featureSetMode = mode;
      this.featureSetQuery = "";
    },
    setFeatureSetQuery(query) {
      this.featureSetQuery = `${query || ""}`;
    },
    toggleFeatureSetEntry(entry) {
      this.featureSetPending = togglePendingEntry(this.featureSetPending, {
        tag: entry?.tag || entry?.title || "",
        type: this.featureSetMode
      });
    },
    removeFeatureSetPending(payload) {
      this.featureSetPending = removePendingEntry(
        this.featureSetPending,
        payload?.tag || payload || ""
      );
    },
    openFeatureSetConfirm() {
      if (!this.featureSetCanSave || this.featureSetSaving) return;
      this.featureSetConfirmOpen = true;
    },
    closeFeatureSetConfirm() {
      this.featureSetConfirmOpen = false;
    },
    async saveFeatureSetChanges() {
      if (this.featureSetSaving) return;
      const poiIds = this.getNormalizedIdList(this.featureSetItemsLoaded || []);
      const addTagIds = [
        ...new Set(
          this.featureSetPending
            .filter(change => change.type === "add")
            .map(change => this.resolveFeatureSetTagId(change.tag))
            .filter(Boolean)
        )
      ];
      const removeTagIds = [
        ...new Set(
          this.featureSetPending
            .filter(change => change.type === "remove")
            .map(change => this.resolveFeatureSetTagId(change.tag))
            .filter(Boolean)
        )
      ];

      if (!poiIds.length || (!addTagIds.length && !removeTagIds.length)) return;

      this.featureSetSaving = true;
      try {
        if (addTagIds.length) {
          await this.runPoiBulkTagUpdate({
            ids: poiIds,
            field: "features",
            tagIds: addTagIds,
            action: "add"
          });
        }
        if (removeTagIds.length) {
          await this.runPoiBulkTagUpdate({
            ids: poiIds,
            field: "features",
            tagIds: removeTagIds,
            action: "remove"
          });
        }
        await this.refreshPois(this.options);
        await this.$store.dispatch(
          "createSuccess",
          `Merkmale fuer ${this.formatNumberDe(
            poiIds.length
          )} POIs gespeichert.`
        );
        this.closeFeatureSetDialog();
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Merkmale konnten nicht gespeichert werden.",
          error
        });
      } finally {
        this.featureSetSaving = false;
      }
    },
    async runPoiBulkTagUpdate({ ids = [], field, tagIds = [], action }) {
      await runBulkTagUpdateRequest({
        apiUrl: `${env.poi_api_client_url}poi/bulk-tags`,
        ids,
        field,
        tagIds,
        action,
        headers: getTokenHeader(),
        getId: value => this.getPoiStateKey(value)
      });
    },
    async openSuggestionReviewDialog() {
      const selectionItems = await this.getDialogSelectionItems();
      if (!selectionItems.length) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens einen editierbaren POI auswählen."
        });
        return;
      }
      const hydratedSelection = await this.enrichDialogItemsWithDetails(
        selectionItems
      );

      this.currentSuggestionType = "category";
      this.suggestedCategoriesById = {};
      this.suggestionErrorsById = {};
      this.appliedSuggestionsById = {};
      this.suggestingItemId = null;
      this.suggestingCategories = false;
      this.applyingCategories = false;
      this.applyCompleted = false;
      this.suggestionsCompleted = false;
      this.dialogItemsLoaded = hydratedSelection;
      this.poiSuggestionDialogOpen = true;
    },
    closeSuggestionDialog() {
      this.poiSuggestionDialogOpen = false;
      this.dialogItemsLoaded = [];
      this.suggestingItemId = null;
      this.suggestingCategories = false;
      this.applyingCategories = false;
      this.suggestedCategoriesById = {};
      this.suggestionErrorsById = {};
      this.appliedSuggestionsById = {};
    },
    setSuggestionType(suggestionType) {
      if (!["category", "feature"].includes(suggestionType)) return;
      this.currentSuggestionType = suggestionType;
      this.suggestingItemId = null;
    },
    getSuggestionMapKey(itemOrId, suggestionType = this.currentSuggestionType) {
      return getSuggestionMapKey(itemOrId, suggestionType, value =>
        this.getPoiStateKey(value)
      );
    },
    getPoiTitle(item) {
      return item?.title || "";
    },
    getMainCategoryLabel(item) {
      return this.getCategoryTitleById(item?.category);
    },
    extractTagLabels(values = [], resolveTitleById = () => "") {
      return extractResolvedLabels(values, {
        resolveTitleById,
        getId: value => this.getPoiStateKey(value),
        labelKeys: ["title", "name", "label"],
        allowRawString: true,
        ignoreMongoIdRawString: true
      });
    },
    getCurrentLabels(item) {
      if (this.currentSuggestionType === "feature") {
        return this.extractTagLabels(
          item?.features || [],
          this.getFeatureTitleById
        );
      }
      return this.extractTagLabels(
        item?.additionalCategories || item?.additional_categories || [],
        this.getCategoryTitleById
      );
    },
    getAppliedStateForItem(item, suggestionType = this.currentSuggestionType) {
      const key = this.getSuggestionMapKey(item, suggestionType);
      return getAppliedStateForItemByKey(this.appliedSuggestionsById, key);
    },
    getSuggestionsForItem(item, suggestionType = this.currentSuggestionType) {
      const key = this.getSuggestionMapKey(item, suggestionType);
      return getSuggestionsForItemByKey(this.suggestedCategoriesById, key);
    },
    getSuggestionErrorForItem(
      item,
      suggestionType = this.currentSuggestionType
    ) {
      const key = this.getSuggestionMapKey(item, suggestionType);
      return getSuggestionErrorForItemByKey(this.suggestionErrorsById, key);
    },
    isItemLoadingSuggestions(
      item,
      suggestionType = this.currentSuggestionType
    ) {
      const key = this.getSuggestionMapKey(item, suggestionType);
      return isItemLoadingSuggestionsByKey(this.suggestingItemId, key);
    },
    getTabSuggestionCount(suggestionType) {
      return countSuggestionItems(
        this.dialogItems,
        suggestionType,
        this.getSuggestionsForItem
      );
    },
    getPoiStartTime() {
      return "-";
    },
    getPoiLocation(item) {
      return item?.address?.city || item?.address?.town || "Unbekannt";
    },
    getPoiText(item) {
      return [
        item?.description?.description,
        item?.description?.seasonalDescription,
        item?.shortDescription?.description,
        item?.shortDescription?.seasonalDescription,
        Array.isArray(item?.searchTerms) ? item.searchTerms.join(", ") : ""
      ]
        .filter(Boolean)
        .join("\n\n");
    },
    loadCategoriesForPrompt() {
      this.categoriesForPrompt = [...this.allCategoryOptions];
    },
    loadFeaturesForPrompt() {
      this.featuresForPrompt = [...this.allFeatureOptions];
    },
    getPossibleCategoriesPayload() {
      const labels = [
        ...new Set(
          (this.categoriesForPrompt || [])
            .map(category => `${category?.title || ""}`.trim())
            .filter(Boolean)
        )
      ];
      return [
        "Moegliche Kategorien:",
        `Anzahl Kategorien: ${labels.length}`,
        labels.length ? labels.join(", ") : "-"
      ].join("\n");
    },
    getPossibleFeaturesPayload() {
      const labels = [
        ...new Set(
          (this.featuresForPrompt || [])
            .map(feature => `${feature?.title || ""}`.trim())
            .filter(Boolean)
        )
      ];
      return [
        "Moegliche Merkmale:",
        `Anzahl Merkmale: ${labels.length}`,
        labels.length ? labels.join(", ") : "-"
      ].join("\n");
    },
    getPossibleItemsPayload() {
      return this.currentSuggestionType === "feature"
        ? this.getPossibleFeaturesPayload()
        : this.getPossibleCategoriesPayload();
    },
    async fetchCategorySuggestion(item) {
      const payload = buildSuggestionPromptPayload({
        currentSuggestionType: this.currentSuggestionType,
        title: this.getPoiTitle(item) || "",
        text: this.getPoiText(item),
        currentLabels: this.getCurrentLabels(item),
        mainCategoryLabel: this.getMainCategoryLabel(item),
        possibleItemsPayload: this.getPossibleItemsPayload(),
        entityLabelGenitive: "des POI",
        contextPhrase: "zum POI"
      });
      const body = {
        principal_id: this.selectedPrincipal?.id || this.selectedPrincipal?._id,
        promptShortId:
          this.currentSuggestionType === "feature"
            ? FEATURE_SUGGESTION_PROMPT_SHORT_ID
            : CATEGORY_SUGGESTION_PROMPT_SHORT_ID,
        payload,
        user: getCurrentUserIdFromSession(
          this.$store.state.currentUser,
          localStorage.getItem("session")
        )
      };

      return executeSuggestionPrompt({
        promptsApiUrl: env.prompts_api_client_url,
        body,
        headers: getTokenHeader() || undefined
      });
    },
    resolveSuggestionLabelToId(label) {
      return this.currentSuggestionType === "feature"
        ? this.resolveFeatureSetTagId(label)
        : this.resolveCategorySetTagId(label);
    },
    mapSuggestionLabelsToIds(suggestions) {
      const missingLabels = [];
      const mappedIds = [];

      suggestions.forEach(label => {
        const mappedId = this.resolveSuggestionLabelToId(label);
        if (mappedId) {
          mappedIds.push(mappedId);
        } else {
          missingLabels.push(label);
        }
      });

      return {
        ids: [...new Set(mappedIds)],
        missingLabels
      };
    },
    async suggestCategoriesForItem(item) {
      if (!item || this.suggestingCategories || this.applyingCategories) return;
      if (!this.selectedPrincipal?.id && !this.selectedPrincipal?._id) {
        this.$set(
          this.suggestionErrorsById,
          this.getSuggestionMapKey(item),
          "Kein Hauptmandant ausgewaehlt."
        );
        return;
      }
      const itemKey = this.getSuggestionMapKey(item);
      if (!itemKey) return;

      this.suggestingItemId = itemKey;
      this.$delete(this.suggestionErrorsById, itemKey);
      try {
        if (this.currentSuggestionType === "feature") {
          if (!this.featuresForPrompt.length) {
            this.loadFeaturesForPrompt();
          }
        } else if (!this.categoriesForPrompt.length) {
          this.loadCategoriesForPrompt();
        }

        const hydratedItems = await this.loadPoiDetailsByIds([item]);
        const fullPoi = hydratedItems[0] || item;
        const dialogIndex = this.dialogItems.findIndex(
          dialogItem =>
            this.getPoiStateKey(dialogItem) === this.getPoiStateKey(item)
        );
        if (dialogIndex >= 0) {
          this.$set(this.dialogItemsLoaded, dialogIndex, {
            ...(this.dialogItemsLoaded[dialogIndex] || item),
            ...(fullPoi || {})
          });
        }

        const sourceItem =
          dialogIndex >= 0 ? this.dialogItemsLoaded[dialogIndex] : fullPoi;
        const suggestions = await this.fetchCategorySuggestion(sourceItem);
        const { ids: mappedIds } = this.mapSuggestionLabelsToIds(suggestions);
        const resolvedLabels = mappedIds
          .map(id =>
            this.currentSuggestionType === "feature"
              ? this.getFeatureTitleById(id)
              : this.getCategoryTitleById(id)
          )
          .filter(Boolean);

        const blockedLabels = new Set(
          this.getCurrentLabels(sourceItem)
            .map(label => this.normalizeCategoryLabel(label))
            .filter(Boolean)
        );
        if (this.currentSuggestionType === "category") {
          const mainCategoryLabel = this.getMainCategoryLabel(sourceItem);
          const normalizedMainLabel = this.normalizeCategoryLabel(
            mainCategoryLabel
          );
          if (normalizedMainLabel) {
            blockedLabels.add(normalizedMainLabel);
          }
        }

        const filteredSuggestions = resolvedLabels.filter(label => {
          return !blockedLabels.has(this.normalizeCategoryLabel(label));
        });
        const existingSuggestions = (
          this.suggestedCategoriesById[itemKey] || []
        ).filter(
          label => !blockedLabels.has(this.normalizeCategoryLabel(label))
        );
        const mergedSuggestions = [
          ...new Set([...existingSuggestions, ...filteredSuggestions])
        ];
        this.$set(this.suggestedCategoriesById, itemKey, mergedSuggestions);

        if (!mergedSuggestions.length) {
          this.$set(
            this.suggestionErrorsById,
            itemKey,
            "Keine passenden Vorschläge gefunden."
          );
          return;
        }
        this.$delete(this.suggestionErrorsById, itemKey);
      } finally {
        this.suggestingItemId = null;
      }
    },
    async suggestCategories() {
      if (!this.dialogItems.length || this.suggestingCategories) return;
      this.suggestingCategories = true;
      try {
        for (let index = 0; index < this.dialogItems.length; index++) {
          // eslint-disable-next-line no-await-in-loop
          await this.suggestCategoriesForItem(this.dialogItems[index]);
        }
        this.suggestionsCompleted = true;
      } finally {
        this.suggestingCategories = false;
      }
    },
    removeSuggestedCategory(item, index) {
      const itemKey = this.getSuggestionMapKey(item);
      if (!itemKey) return;
      const list = [...(this.suggestedCategoriesById[itemKey] || [])];
      if (index < 0 || index >= list.length) return;
      list.splice(index, 1);
      this.$set(this.suggestedCategoriesById, itemKey, list);
    },
    async applySingleSuggestedCategory(item, label, index) {
      const itemKey = this.getSuggestionMapKey(item);
      if (!itemKey) return;
      const list = [...(this.suggestedCategoriesById[itemKey] || [])];
      if (list[index] !== label) return;
      this.$set(this.suggestedCategoriesById, itemKey, [label]);
      await this.applySuggestionsForItem(item);
    },
    async applySuggestionsForItem(item) {
      if (!item || this.suggestingCategories || this.applyingCategories) return;
      const itemKey = this.getSuggestionMapKey(item);
      const suggestions = this.suggestedCategoriesById[itemKey] || [];
      if (!suggestions.length) return;

      const isFeature = this.currentSuggestionType === "feature";
      const resolvedIds = suggestions
        .map(label =>
          isFeature
            ? this.resolveFeatureSetTagId(label)
            : this.resolveCategorySetTagId(label)
        )
        .filter(Boolean);

      if (!resolvedIds.length) {
        this.$set(
          this.suggestionErrorsById,
          itemKey,
          `Keine ${this.suggestionTypeLabel.toLowerCase()} gefunden.`
        );
        return;
      }

      const poiId = this.getPoiStateKey(item);
      const dialogIndex = this.dialogItems.findIndex(
        dialogItem => this.getPoiStateKey(dialogItem) === poiId
      );
      const sourcePoi =
        this.pois.find(poi => this.getPoiStateKey(poi) === poiId) || item;
      const currentIds = this.getNormalizedIdList(
        isFeature
          ? sourcePoi?.features || []
          : sourcePoi?.additionalCategories ||
              sourcePoi?.additional_categories ||
              []
      );
      const idsToAdd = resolvedIds.filter(id => !currentIds.includes(id));

      if (!idsToAdd.length) {
        this.$set(this.appliedSuggestionsById, itemKey, true);
        this.$delete(this.suggestionErrorsById, itemKey);
        this.$set(this.suggestedCategoriesById, itemKey, []);
        return;
      }

      const field = isFeature ? "features" : "additionalCategories";

      this.applyingCategories = true;
      try {
        await this.runPoiBulkTagUpdate({
          ids: [sourcePoi],
          field,
          tagIds: idsToAdd,
          action: "add"
        });

        const refreshedItems = await this.loadPoiDetailsByIds([sourcePoi]);
        const refreshedItem = refreshedItems[0] || null;
        const nextIds = [...new Set([...currentIds, ...idsToAdd])];
        const fallbackUpdatedItem = isFeature
          ? { ...item, features: nextIds }
          : {
              ...item,
              additionalCategories: nextIds,
              additional_categories: nextIds
            };
        const mergedItem = refreshedItem || fallbackUpdatedItem;

        if (dialogIndex >= 0) {
          this.$set(this.dialogItemsLoaded, dialogIndex, {
            ...(this.dialogItemsLoaded[dialogIndex] || item),
            ...mergedItem
          });
        } else if (isFeature) {
          this.$set(item, "features", nextIds);
        } else {
          this.$set(item, "additionalCategories", nextIds);
          this.$set(item, "additional_categories", nextIds);
        }
        this.$set(this.appliedSuggestionsById, itemKey, true);
        this.$delete(this.suggestionErrorsById, itemKey);
        this.$set(this.suggestedCategoriesById, itemKey, []);
      } catch (error) {
        this.$set(
          this.suggestionErrorsById,
          itemKey,
          "Speichern fehlgeschlagen."
        );
      } finally {
        this.applyingCategories = false;
      }
    },
    discardSuggestionsForItem(item) {
      const itemKey = this.getSuggestionMapKey(item);
      if (!itemKey) return;
      this.$set(this.suggestedCategoriesById, itemKey, []);
      this.$delete(this.suggestionErrorsById, itemKey);
      this.$set(this.appliedSuggestionsById, itemKey, false);
    },
    handleCategoryDialogAction() {
      this.closeSuggestionDialog();
    },
    nextPage() {
      const total = this.poiCount;
      const perPage = this.itemsPerPage;
      const totalPages = Math.ceil(total / perPage);

      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    getCategoryType(categoryType) {
      const foundCatType = this.categoryTypes.find(
        ct => ct._id === categoryType
      );
      if (foundCatType?.title) return foundCatType.title;
      else return "---";
    },
    morePictures(item) {
      return item.allPictures > 1;
    },
    previewImage(item) {
      const url = item?.picture?.url;
      return this.getThumbnailUrl(url, "pois", 70, "-");
    },
    setToLocalStorage(value) {
      localStorage.setItem("itemsPerPage", value);
    },
    async getPoi(item) {
      const headers = getTokenHeader();
      try {
        const { data } = await axios.get(
          `${env.poi_api_client_url}poi/${item._id}`,
          {
            headers
          }
        );
        return data;
      } catch (error) {
        this.createError(error);
      }
    },
    async editItem(item) {
      this.editedIndex = this.pois.indexOf(item);
      const data = await this.getPoi(item);

      /***************************************************************
       * Lodash merge, damit Subobjekte übernommen werden
       *
       * Das leere Objekt am Anfang ist dafür, dass das defaultItem
       * nicht überschrieben wird
       ***************************************************************/
      this.editedItem = _.merge({}, defaultPoi, data);
      await this.$store.dispatch(
        "getCategoriesByGroup",
        this.editedItem.categoryGroup
      );
      this.changed = false;
      this.dialog = true;
    },
    async deletePoi(poi) {
      const id = poi._id;
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie dieses Element löschen wollen?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        const data = await this.getPoi(poi);
        data.pictures.forEach(pic => {
          destroyFile("pois", pic.id);
        });
        if (data.logo) {
          destroyFile("pois", getMongoFileId({ url: data.logo }));
        }
        if (data.route?.gpx?.url) {
          destroyFile("pois", getMongoFileId(data.route.gpx));
        }
        if (data.route?.image?.id) {
          destroyFile("pois", data.route.image.id);
        }
        try {
          const headers = getTokenHeader();
          const res = await axios.delete(`${env.poi_api_client_url}poi/${id}`, {
            headers
          });
          if (res.status === 200) {
            await this.refreshPois(this.options);
            this.createSuccess("Erfolgreich gelöscht!");
          }
        } catch (error) {
          this.createError(error);
        }
      }
    },
    async close() {
      if (this.changed) {
        const isConfirmed = await this.$confirm(
          "Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!",
          confirmWarningConfig
        );
        if (isConfirmed) {
          this.editedItem = Object.assign({}, this.editedItem); // reactivity
          this.closeAction();
        }
      } else this.closeAction();
    },
    closeAction() {
      this.dialog = false;
      this.isValid = true;
      this.$nextTick(() => {
        this.$refs.editDialog?.$refs?.stepWrapper?.$refs?.media?.clear();
        this.$refs.editDialog?.$refs?.stepWrapper?.$refs?.processingStatus?.$refs?.logOverview?.resetLogs();
        this.$refs.form?.reset();

        this.step = 1;
        this.editedItem = Object.assign({}, { ...defaultPoi });
        this.editedIndex = -1;
        if (this.editId) this.$router.replace("/poi");
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, { ...defaultPoi });
        this.editedIndex = -1;
      });
    },
    async save(close) {
      let response = false;
      if (!this.editedItem.principal)
        this.editedItem.principal = this.principal.id;

      try {
        if (this.editedItem.logo && typeof this.editedItem.logo !== "string") {
          const res = await uploadFile(
            this.editedItem.logo,
            this.editedItem.id || this.editedItem._id,
            "pois",
            this.editedItem.principal
          );
          this.editedItem.logo = res.url;
        }

        if (this.editedItem.features?.some(f => typeof f === "object"))
          this.editedItem.features = this.editedItem.features.filter(
            feature => !!feature
          );

        response = this.editedItem._id
          ? await this.updatePoi()
          : await this.createPoi();
      } catch (ex) {
        this.createError(ex);
      }

      this.destroyList.forEach(id => {
        destroyFile("pois", id);
      });
      this.destroyList = [];

      if (response?.status === 200 || response?.status === 201) {
        try {
          await this.refreshPois(this.options);
        } catch (ex) {
          this.createError(ex);
          return;
        }
        // update calculatedOpeningHours in gui
        // f.e. used for closedWeekDays
        if (response?.data?.calculatedOpeningHours) {
          this.editedItem.calculatedOpeningHours =
            response.data.calculatedOpeningHours;
          // reactivity
          this.editedItem = Object.assign({}, this.editedItem);
        }
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
        if (response?.status === 201 && response?.data?._id) {
          const createdPoi = await axios.get(
            `${env.poi_api_client_url}poi/${response.data._id}`,
            {
              headers: getTokenHeader()
            }
          );

          this.editedItem = createdPoi.data;
          this.editedItem = Object.assign(
            {
              ...defaultPoi
            },
            this.editedItem
          );
        }

        const logOverviewRef = this.$refs.editDialog.$refs.stepWrapper.$refs
          .processingStatus.$refs.logOverview;
        const logsFetched = logOverviewRef?.logsFetched;
        logOverviewRef?.resetLogs();

        if (close) {
          this.closeAction();
        } else if (logsFetched) {
          logOverviewRef?.getLogs().then(null);
        }
      }
    },
    async createPoi(poi) {
      if (!poi) poi = this.editedItem;
      const headers = getTokenHeader(),
        res = await axios.post(`${env.poi_api_client_url}poi`, poi, {
          headers
        });
      return res.status >= 200 && res.status < 300 ? res : false;
    },
    async updateOplocHelper(poi) {
      if (!poi?.events_module?.oploc_id?.length) return;
      const types = [];

      if (poi?.events_module?.isOperator) types.push("operator");
      if (poi?.events_module?.isLocation) types.push("location");

      if (!types?.length) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens einen Typ auswählen!"
        });
        return;
      }

      const oplocToUpdate = {
        _id: poi.events_module?.oploc_id,
        title: poi.title,
        principal_id: poi.principal,
        poi_id: poi._id,
        type: types,
        address: {
          ...poi.address,
          additional_address: poi?.address?.additionalAddress || "",
          phone: poi?.address?.phoneNumber || "",
          mobile: poi?.address?.mobileNumber || "",
          email: poi?.address?.eMail || ""
        }
      };
      if (poi.geo.lng && poi.geo.lat) {
        oplocToUpdate.geo = {
          type: "Point",
          coordinates: [poi.geo.lng, poi.geo.lat]
        };
      } else {
        oplocToUpdate.geo = {
          type: "Point",
          coordinates: []
        };
      }

      await this.updateOpLoc(oplocToUpdate);
    },
    async updatePoi(poi) {
      if (!poi) poi = this.editedItem;
      if (poi?.events_module?.oploc_id?.length) {
        try {
          await this.updateOplocHelper(poi);
        } catch (e) {
          console.error(e);
          await this.$store.dispatch("createError", {
            text: "Fehler beim Aktualisieren des Veranstalters/Standorts"
          });
        }
      }
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.poi_api_client_url}poi/${poi.id || poi._id}`,
          poi,
          { headers }
        );
      return res.status >= 200 && res.status < 300 ? res : false;
    },
    createError(error) {
      this.$store.dispatch("createError", error);
    },
    createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    // Baut den updatedAt string für die Tabelle zusammen,
    // da moment im Template nicht verfügbar ist
    buildUpdatedAt: at => `${moment(at).format("DD.MM.YYYY HH:mm")}`,

    async changeCheckboxState(item, property) {
      if (!item.deleted) {
        const res = await this.$confirm(
          "Wollen Sie diese Änderung wirklich vornehmen?",
          confirmWarningConfig
        );
        if (res) item[property] = !item[property];
        const updatePoiData = { _id: item._id, slug: item.slug };
        updatePoiData[property] = item[property];
        await this.updatePoi(updatePoiData);
      }
    },
    changeStep(value) {
      this.step = value;
    },
    async resetFilter() {
      this.filter = { ..._.cloneDeep(defaultFilter) };
      await this.applyFilter(this.filter);
    },
    async applyFilter() {
      this.loading = true;
      await this.refreshPois(this.options);
      this.loading = false;
    },
    exportCsv(imageType) {
      this.downloadList("csv", imageType);
    },
    exportXlsx(imageType) {
      this.downloadList("xlsx", imageType);
    },
    async exportJson() {
      const data = await this.getExportPois();
      forceFileDownload(JSON.stringify(data), "pois.json");
    },
    async exportImages() {
      try {
        this.overlay = true;
        this.exportingImages = true;
        const exportPois = await this.getExportPois({ forImageExport: true });
        let _ids = [];
        exportPois.forEach(poiArray => {
          poiArray.forEach(poi => {
            _ids.push(poi._id);
          });
        });
        _ids = _.uniq(_ids);
        if (!_ids.length) return;

        const idBatches = _.chunk(_ids, 100);
        const headers = getTokenHeader();
        for (let i = 0; i < idBatches.length; i++) {
          const { data } = await axios.post(
            `${env.poi_api_client_url}poi/exportImages`,
            {
              _ids: idBatches[i]
            },
            {
              headers,
              responseType: "arraybuffer"
            }
          );
          const fileName =
            idBatches.length === 1 ? "poiBilder.zip" : `poiBilder_${i + 1}.zip`;
          forceFileDownload(data, fileName);
        }
      } catch (error) {
        this.createError(error);
      } finally {
        this.exportingImages = false;
        this.overlay = false;
      }
    },
    async getExportPois(options = {}) {
      let data = [];
      let queryIds = [[]];
      let index = 0;

      if (options.forImageExport && this.poiCount > 200) {
        const confirm = await this.$confirm(
          "Es werden die Bilder von mehr als 200 POIs exportiert. Dies kann einige Zeit in Anspruch nehmen. Wollen Sie fortfahren?",
          confirmWarningConfig
        );
        if (!confirm) {
          return [];
        }
      }

      await this.refreshPois({ ...this.options, getAllIds: true });

      this.allPois.forEach(id => {
        if (queryIds[index].length < 200) queryIds[index].push(id);
        else {
          queryIds.push([]);
          index++;
          queryIds[index].push(id);
        }
      });
      try {
        const headers = getTokenHeader();
        await queryIds.asyncForEach(async reqPackage => {
          const result = await axios.post(
            `${env.poi_api_client_url}poi/exportPois`,
            reqPackage,
            {
              headers
            }
          );
          if (result?.status === 200) {
            result?.data?.forEach(poi => {
              data.push(poi);
            });
          } else {
            this.createError("Etwas ist schiefgelaufen");
          }
        });
      } catch (error) {
        this.createError(error);
      }
      return data;
    },
    syncSelectedWithLatestPois(selectedIds = []) {
      if (!selectedIds.length) {
        this.selectedPois = [];
        return;
      }
      this.selectedPois = syncSelectionWithLatestItems(
        selectedIds,
        this.pois,
        item => this.getPoiStateKey(item)
      );
    },
    async refreshPois(options) {
      this.loading = true;
      const selectedIdsBeforeRefresh = this.selectedPois
        .map(item => this.getPoiStateKey(item))
        .filter(Boolean);
      // Cancel any in-progress requests
      if (this.currentSearchRequest) {
        this.currentSearchRequest.cancel(
          "Operation canceled due to new request"
        );
      }

      // Create a new cancellation token
      this.currentSearchRequest = axios.CancelToken.source();

      try {
        const query = buildQuery(
          options,
          this.search,
          this.filter,
          this.$store.state.selectedPrincipal
        );

        const result = await getPois(
          query,
          this.principal._id,
          this.currentSearchRequest.token
        );
        this.loading = false;

        this.allPois = result?.allIds[0];
        this.pois = result?.pois;
        if (!this.isAdmin) this.pois = this.pois.filter(poi => !poi.deleted);
        this.poiCount = result?.total;
        if (this.allPagesSelected) {
          this.selectedPois = [
            ...this.pois.filter(poi => this.canEditPoi(poi))
          ];
        } else {
          this.syncSelectedWithLatestPois(selectedIdsBeforeRefresh);
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.info("Request cancelled successfully.");
          return;
        }
        this.loading = false;
        throw error;
      }
    },
    async downloadList(type, imageType) {
      const TABLE_TITLE_LINE = [
        "ID",
        "Titel",
        "Typ",
        "Kategorie",
        "Ort",
        "geändert",
        "durch",
        "aktiv (veröffentlicht)",
        "Top-POI",
        "Straße",
        "Adresse 2. Zeile",
        "PLZ",
        "Ort",
        "Land",
        "Telefon",
        "Mobil",
        "E-Mail",
        "Website",
        "Kontakt-Mail",
        "Bilder",
        "Mapping Felder",
        "Regionsberechtigung"
      ];
      const table = [TABLE_TITLE_LINE];
      this.overlay = true;
      const data = await this.getExportPois();
      data.forEach(nestedData => {
        nestedData.forEach(poi => {
          const address = poi[poi?.contact?.showContact];
          let poiImage = "";
          poi.pictures?.forEach(pic => {
            if (pic?.customTypes[0] === imageType) {
              poiImage = pic.url;
            }
            if (!poiImage && imageType === "1. Bild") {
              poiImage = pic.url;
            }
          });

          table.push([
            poi._id,
            poi.title,
            this.categoryTypesById[poi.categoryType] ?? "",
            this.categoriesById[poi.category] ?? "---",
            poi.address?.city,
            this.buildUpdatedAt(poi.updatedAt),
            this.getUpdatedByStringForExport(poi),
            poi.active ? 1 : 0,
            poi.highlight ? 1 : 0,
            address?.address ?? "",
            address?.additionalAddress ?? "",
            address?.zip ?? "",
            address?.city ?? "",
            address?.country ?? "",
            address?.phoneNumber ?? "",
            address?.mobileNumber ?? "",
            address?.eMail ?? "",
            address?.website ?? "",
            address?.contactEMail ?? "",
            poiImage,
            poi.additionalData
              ? poi.additionalData
                  .map(data => `${data.typeId}: ${data.value}`)
                  ?.join("; ")
              : "",
            this.getPermissionsForRegionsByPoi(poi)
          ]);
        });
      });
      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(table);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "POIs");
      XLSX.writeFile(workbook, `pois.${type}`);
      this.overlay = false;
    },
    getUpdatedByStringForExport(poi) {
      const updatedBy = this.getUsersNameById(poi.updatedBy);
      if (updatedBy?.trim()?.length) {
        return updatedBy;
      }
      if (poi.updatedByImport || poi.lastChangedImportDataSource) {
        return "Import";
      }
      return "----";
    },
    getUsersNameById(id) {
      const user = this.users.find(u => u.id === id);
      return `${user?.first_name ?? ""} ${user?.last_name ?? ""}`;
    },
    async cloneFiles(clone) {
      await clone.pictures.asyncForEach(async pic => {
        await this.copyPicture(pic);
      });
      if (clone.logo) {
        const newLogo = await copyFileById(
          getMongoFileId({ url: clone.logo }),
          getPictureUrlDatePath(clone.logo)
        );
        clone.logo = newLogo.url;
      }
      if (clone.route?.gpx?.url) {
        const newGpx = await copyFileById(
          getMongoFileId(clone.route.gpx),
          getPictureUrlDatePath(clone.route.gpx)
        );
        if (newGpx) {
          clone.route.gpx.id = newGpx.id;
          clone.route.gpx.url = newGpx.url;
        }
      }
      if (clone.route?.image?.url) {
        const newGpxImage = await copyFileById(
          clone.route.image.id,
          getPictureUrlDatePath(clone.route.image.url)
        );
        if (newGpxImage) {
          clone.route.image.id = newGpxImage.id;
          clone.route.image.url = newGpxImage.url;
        }
      }
    },
    async copyPoi(item) {
      const isConfirmed = await this.$confirm(
        "Möchten Sie dieses Element wirklich kopieren?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        const data = await this.getPoi(item);
        const clone = { ...data, active: false };
        delete clone.slug;
        await this.cloneFiles(clone);
        delete clone._id;
        try {
          const response = await this.createPoi(clone);
          if (response) {
            await this.refreshPois(this.options);
            this.createSuccess("Erfolgreich kopiert!");
            const itemToEdit = this.pois.find(
              poi => poi._id === response.data?._id
            );
            if (itemToEdit) await this.editItem(itemToEdit);
          }
        } catch (err) {
          this.createError(err);
        }
      }
    },
    // copy picture and update image-urls
    async copyPicture(picture) {
      const oldPictureId = picture.id;
      const oldPictureDatePath = getPictureUrlDatePath(picture.url);
      try {
        const newFile = await copyFileById(oldPictureId, oldPictureDatePath);
        picture.id = newFile.id;
        picture.url = newFile.url;
        let sizes = picture.imageSizes;
        if (sizes) {
          const newPictureDatePath = getPictureUrlDatePath(newFile.url);
          Object.keys(sizes).forEach(key => {
            const find = `${oldPictureDatePath ?? "/"}${oldPictureId}`;
            const replace = `${newPictureDatePath}${newFile.id}`;
            sizes[key].url = sizes[key].url.replace(find, replace);
          });
        }
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    async openCreateDialog() {
      if (this.editedItem?.categoryGroup)
        await this.$store.dispatch(
          "getCategoriesByGroup",
          this.editedItem.categoryGroup
        );

      this.typeDialog = false;
      this.dialog = true;
    },
    cancelCreateDialog() {
      this.editedItem.categoryGroup = "";
      this.typeDialog = false;
    },
    getPermissionsForRegionsByPoi(poi) {
      return this.regions
        .map(region => {
          const regionPoi = region.pois?.find(rPoi => rPoi._id === poi?._id);
          if (regionPoi)
            return `${region.title} - ${this.mapPermissions(
              regionPoi.permissions
            )}`;
          else return null;
        })
        ?.filter(item => !!item)
        ?.join("; ");
    },
    mapPermissions(permissions) {
      switch (permissions) {
        case "read":
          return "Lesen";
        case "write":
          return "Schreiben";
        case "admin":
          return "Admin";
        case "status":
          return "Statusbearbeitung";
        default:
          return "Lesen";
      }
    },
    forceUndefinedInsteadOfZeroStateValue(newValue, oldValue, property) {
      if (oldValue === newValue) {
        return;
      }
      if (oldValue === undefined && newValue === 0) {
        this.editedItem.state[property] = undefined;
      }
    }
  }
};
